export default class SimpleUrl {
  pageUrl = null;
  simpleUrls = null;

  constructor(simpleUrls, pageUrl) {
    this.pageUrl = pageUrl;
    const rewriteUrls = simpleUrls.filter(url => url.filters);
    const otherUrls = simpleUrls.filter(url => !url.filters);
    this.simpleUrls = [ ...rewriteUrls, ...otherUrls ];
  }

  getAllTokens = searchOption => {
    const urls = this.simpleUrls.filter(url => url.path.split("/")[0] === searchOption);
    const allTokens = urls.reduce((result, url) => {
      const tokens = this.getTokens(url.path) || [];
      return [...result, ...tokens, "searchOption"];
    }, []);
    return allTokens;
  };

  isRewriteUrl = (url, filters, searchOption, tokens) => {
    const locationSearchBy = window.location.pathname.split("/")[2];
    const key = url.path.split("/")[0];
    if (url.filters) {
      const { journey = null, ...otherFilters } = url.filters;
      if (
        Object.entries(otherFilters).every(
          ([k, v]) => Object.keys(filters).includes(k) && filters[k][0] === v,
        ) &&
        journey &&
        journey === searchOption &&
        key === locationSearchBy &&
        !tokens
      ) {
        return true;
      }
    }
    return false;
  };

  matchUrl = (url, filters, searchOption) => {
    const tokens = this.getTokens(url.path);
    const allTokens = this.getAllTokens(searchOption);
    const tokensWithValue = tokens
      ? tokens.filter(token => Object.keys(filters).includes(token) && filters[token])
      : [];
    let keys = [...Object.keys(filters).filter(key => allTokens.includes(key))];
    const searchBy = url.path.split("/")[0];
    const isRewriteUrl = this.isRewriteUrl(url, filters, searchOption, tokens);
    if (tokens && searchBy === searchOption && tokens.length !== tokensWithValue.length) {
    }
    if (
      (tokens &&
        tokens.every(token => keys.includes(token)) &&
        tokens.length === keys.length &&
        searchBy === searchOption) ||
      (tokens && !tokensWithValue.length && searchBy === searchOption) ||
      isRewriteUrl
    ) {
      return true;
    }
    return false;
  };

  getMatchedUrl = (filters, searchOption) => {
    const urls = this.simpleUrls.filter(url => this.matchUrl(url, filters, searchOption));
    const rewriteUrl = urls ? urls.find(url => url.filters) : null;
    let url = rewriteUrl || urls ? urls[0] : null;
    const tokens = url ? this.getTokens(url.path) : null;
    const tokensWithValue = tokens
      ? tokens.filter(token => Object.keys(filters).includes(token) && filters[token])
      : [];
    if ((tokens && tokens.length !== tokensWithValue.length) || !url) url = { path: searchOption };
    return url;
  };

  formatUrl = (url, tokens, filters = {}) => {
    let path = url;
    if (tokens) {
      tokens.forEach(token => {
        const replace = filters[token] ? `/${filters[token]}` : "";
        path = path.replace(`/{${token}}`, replace);
      })
    }
    return `${this.pageUrl}/${path}`;
  };

  getTokens = url => {
    if (url) {
      const matches = url.match(/\{\w+\}/g) || [];
      return matches.length ? matches.map(m => m.replace("{", "").replace("}", "")) : null;
    }
    return null;
  };

  createRoutePath = (path, tokens) => {
    let route = path;
    if (tokens) {
      tokens.forEach(token => {
        route = route.replace(`{${token}}`, `:${token}?`);
      })
    }
    return `/${route}`;
  };

  formatRoutePath = url => {
    const { path, filters = null } = url;
    const tokens = this.getTokens(url.path);
    let routePath = this.createRoutePath(path, tokens);
    routePath = { path: routePath };
    if (filters) routePath = { ...routePath, filters };
    return routePath;
  };

  getRouteUrl = key => {
    const allUrls = this.simpleUrls.filter(url => url.path.split("/")[0] === key);
    let longest = 0;
    let routeUrl = allUrls[0].path;
    allUrls.forEach(url => {
      const length = url.path.split("/").length;
      if (length > longest) {
        routeUrl = url;
        longest = length;
      }
    });
    return this.formatRoutePath(routeUrl);
  };

  getRoutes = () => {
    let routes = [];
    let paths = [];
    this.simpleUrls.forEach((url, i) => {
      const key = url.path.split("/")[0];
      const routeUrl = this.getRouteUrl(key);
      if (!paths.includes(routeUrl.path)) {
        paths = [...paths, routeUrl.path];
        routes = [...routes, routeUrl];
      }
    });
    return routes;
  };

  getQueryString = (filters, searchOption) => {
    const url = this.getMatchedUrl(filters, searchOption.key);
    if (url) {
      const tokens = this.getTokens(url.path);
      let queryStringFilters = tokens
        ? Object.entries(filters).reduce((result, [key, value]) => {
            if (!tokens.includes(key)) result = { ...result, [key]: value };
            return result;
          }, {})
        : null;
      if (!tokens) queryStringFilters = filters;
      if (url.filters) {
        queryStringFilters = Object.entries(queryStringFilters).reduce((result, [k, v]) => {
          if (!Object.keys(url.filters).includes(k)) result = { ...result, [k]: v };
          return result;
        }, {});
      }
      return queryStringFilters;
    }
    return null;
  };

  getUrl = (filters, searchOption) => {
    const url = this.getMatchedUrl(filters, searchOption);
    const tokens = url && url.path ? this.getTokens(url.path) : null;
    return url ? this.formatUrl(url.path, tokens, filters) : url;
  };

  getParams = () => this.params;
}
